import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import { ConfigService, MQComponent, MQService, MessagingService, CONFIGDATA } from '@ngxsuit';
import { ConfigService, MQComponent, MQService, CONFIGDATA } from '@ngxsuit';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers:[ConfigService]
})
export class AppComponent extends MQComponent implements OnInit  {
    constructor(
        protected mq: MQService,
        private config: ConfigService,
        // private msgService: MessagingService,
        private http:HttpClient) {
        super(mq);
        this.resolveConfig();
    }

    async resolveConfig() {
        await this.config.resolve('/configs.json');
    }

    ngOnInit() {
        // super.listenOn('firebase-token-updated', msg => {
        //     //subscribe firebase topics
        //     // this.http.post(this.config.getString('base_url') + '/firebase/topics', msg).subscribe(resp => {
        //     //     console.log('notification topic subscribed',resp);
        //     // })
        // })
        // this.msgService.getPermission()
        // this.msgService.receiveMessage()
    }
}